import * as t from './actionTypesSagas';

export const deleteTaskNotification = (taskId) => ({
  type: t.DELETE_TASK_NOTIFICATION,
  taskId,
});
